/* IMPORT */
import { BATCH } from '../context.js';
import { Stack } from '../methods/debugger.js';
/* MAIN */
// Using 2 microtasks to give a chance to things using 1 microtask (like refs in Voby) to run first
class Scheduler {
    constructor() {
        /* VARIABLES */
        this.waiting = [];
        this.locked = false;
        this.queued = false;
        /* QUEUING API */
        this.flush = (stack) => {
            if (this.locked)
                return;
            if (!this.waiting.length)
                return;
            try {
                this.locked = true;
                while (true) {
                    const queue = this.waiting;
                    if (!queue.length)
                        break;
                    this.waiting = [];
                    for (let i = 0, l = queue.length; i < l; i++) {
                        queue[i][0].update(queue[i][1]);
                    }
                }
            }
            finally {
                this.locked = false;
            }
        };
        this.queue = (stack) => {
            if (this.queued)
                return;
            this.queued = true;
            this.resolve(stack);
        };
        this.resolve = (stack) => {
            queueMicrotask(() => {
                queueMicrotask(() => {
                    if (BATCH) {
                        BATCH.finally(() => this.resolve(stack));
                    }
                    else {
                        this.queued = false;
                        this.flush(stack);
                    }
                });
            });
        };
        /* SCHEDULING API */
        this.schedule = (effect, stack) => {
            this.waiting.push([effect, stack]);
            this.queue(stack);
        };
    }
}
/* EXPORT */
export default new Scheduler();
